<template>
  <my-giving-layout :enable-scroll-event="true">
    <div class="bg-[#F6F4F0] w-full h-viewport">
      <BackButton class="w-full px-[20px] mb-[16px]" :customBack="back" />
      <div class="px-[24px] pb-[48px]">
        <TitheHeader></TitheHeader>
        <div
          class="mt-[32px] md:mt-[40px] lg:mt-[48px] mb-[40px] md:mb-[48px] lg:mb-[56px] flex flex-col gap-[20px] md:gap-[24px] lg:gap-[28px]"
        >
          <GivingDropdown
            :selected="selectedYear"
            :options="titheYears"
            type="tithe"
            class="w-[120px] md:w-[160px] lg:w-[180px] min-h-[48px] md:min-h-[52px] lg:min-h-[56px] rounded-[12px]"
          ></GivingDropdown>
          <TableTithe :transactionDates="titheTableRecords"></TableTithe>
          <p class="pt-20px text-black">
            Your tithing history is based on your Personalised Reference Number provided during
            online giving or on the giving envelope.
          </p>
          <p class="pt-20px text-black">
            Do note that your giving will be reflected on your page within 3-5 working days.
          </p>
        </div>
        <GiveNowButton class="mb-[40px]" />
        <AdditionalInfo />
      </div>
    </div>
  </my-giving-layout>
</template>

<script>
import { mapState } from 'vuex';
import BackButton from '@/components/common/BackButton.vue';
import TitheHeader from '@/components/MyGiving/TitheHistoryPage/Header.vue';
import GivingDropdown from '@/components/MyGiving/BuildingFundPage/GivingDropdown.vue';
import TableTithe from '@/components/MyGiving/TitheHistoryPage/TableTithe.vue';
import AdditionalInfo from '@/components/MyGiving/Common/AdditionalInfo.vue';
import GiveNowButton from '@/components/MyGiving/Common/GiveNowButton.vue';
import RegisterBackHandler from '@/mixins/RegisterBackHandler.js';
import MyGivingLayout from '@/components/MyGivingLayout.vue';
export default {
  mixins: [RegisterBackHandler],
  components: {
    BackButton,
    TitheHeader,
    GivingDropdown,
    TableTithe,
    AdditionalInfo,
    GiveNowButton,
    MyGivingLayout,
  },
  methods: {
    back() {
      this.$router.replace('/my-giving');
    },
  },
  computed: {
    ...mapState('myGiving', ['titheYears', 'titheRecord', 'selectedYear', 'titheTableRecords']),
  },
  async ionViewWillEnter() {
    await this.$store.dispatch('myGiving/getTitheYears');

    await this.$store.commit('myGiving/setSelectedYear', this.$route.params.id);

    await this.$store.dispatch('myGiving/getTitheRecordByYear', this.$route.params.id);

    await this.$store.commit('myGiving/setTitheTableRecords');
  },
};
</script>
<style scoped>
* {
  font-family: 'Inter';
}
</style>
